import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const F = '"Microsoft YaHei", "微软雅黑", sans-serif';

const DEFAULTS = {
  title_en: 'ADU PACKAGES', title_zh: 'ADU 套餐方案',
  subtitle_en: 'Compare our four standardized packages. All packages include quality construction with JM Fiberglass insulation, Dunn Edwards paint, and Cooper plumbing.',
  subtitle_zh: '比较我们四种标准化套餐。所有套餐均包含 JM Fiberglass 保温材料、Dunn Edwards 油漆和 Cooper 管道。',
  packages: [
    { version: 'V1.0', name_en: 'Standard', name_zh: '标准版', desc_en: 'Quality construction with essential features', desc_zh: '优质施工，基本配置' },
    { version: 'V2.0', name_en: 'Premium', name_zh: '高级版', desc_en: 'Upgraded materials and enhanced features', desc_zh: '升级材料，增强配置' },
    { version: 'V3.0', name_en: 'Luxury', name_zh: '豪华版', desc_en: 'High-end finishes and luxury amenities', desc_zh: '高端装修，豪华配置' },
    { version: 'V4.0', name_en: 'Smart Luxury', name_zh: '智能豪华版', desc_en: 'Fully integrated smart home technology', desc_zh: '全面智能家居集成' },
  ]
};

const ADUPackagesSection = () => {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  const [cfg, setCfg] = useState(DEFAULTS);

  useEffect(() => {
    axios.get(`${API}/admin/settings/adu_packages`).then(r => {
      if (r.data?.value?.packages) setCfg(r.data.value);
    }).catch(() => {});
  }, []);

  const l = (en, zh) => isZh ? (zh || en) : (en || zh);

  return (
    <section id="packages" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-8 sm:mb-12 px-4 sm:px-0">
          <h2 className="uppercase tracking-wide mb-4 sm:mb-5 text-3xl sm:text-5xl font-black" style={{ fontFamily: F, color: '#1a2332' }}>
            {l(cfg.title_en, cfg.title_zh)}
          </h2>
          <p className="max-w-3xl mx-auto text-sm sm:text-lg" style={{ fontFamily: F, color: '#555' }}>
            {l(cfg.subtitle_en, cfg.subtitle_zh)}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mb-8 sm:mb-12">
          {(cfg.packages || []).map(pkg => (
            <Card key={pkg.version} className="shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-0 rounded-2xl overflow-hidden">
              <CardContent className="p-4 sm:p-8 text-center flex flex-col items-center justify-center min-h-[180px] sm:min-h-[280px]">
                <div className="mb-3 sm:mb-5 text-sm sm:text-xl" style={{ fontFamily: F, color: '#dc2626' }}>{pkg.version}</div>
                <h3 className="mb-4 sm:mb-8 text-xl sm:text-4xl font-bold" style={{ fontFamily: F, color: '#111' }}>{l(pkg.name_en, pkg.name_zh)}</h3>
                <p className="text-xs sm:text-base" style={{ fontFamily: F, color: '#888' }}>{l(pkg.desc_en, pkg.desc_zh)}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/packages">
            <Button size="lg" className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-6 text-lg rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
              {t('packages.viewFull')}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ADUPackagesSection;
